import { Fragment } from "react";
import { Outlet, useSearchParams } from "react-router";
import { useAccount } from "./session";
import { setDisplayLocale, setOrgLocale } from "../lib/format";
import { LangContext, pickLang, setDateFormat, setSchweizerSchreibung, setUiLang } from "../lib/sprache";
import { useDocumentLang } from "../components/shell/WebLayout";

/**
 * Sprache für die eigenständigen Seiten außerhalb der Portalrahmen (Einrichtung, Registrieren, Passwort, Konto · Sicherheit),
 * PARITAET-8: ausdrücklich gewählte Sprache im Link (?sprache=en, wie bei der Anmeldung) → eigene Wahl im Profil →
 * Sprache der Agentur → Deutsch.
 */
export function SpracheRahmen() {
  const { account } = useAccount();
  const [params] = useSearchParams();
  const first = account?.memberships[0];
  const org = first ? account?.orgs[first.org_id] : undefined;
  const lang = pickLang(params.get("sprache"), account?.language, org?.locale);
  setUiLang(lang);
  setDateFormat(account?.dateFormat);
  setDisplayLocale(lang === "en" ? "en-GB" : org?.locale);
  setOrgLocale(org?.locale);
  setSchweizerSchreibung(lang === "de" ? org?.locale : null);
  useDocumentLang(lang);
  return (
    <LangContext.Provider value={lang}>
      <Fragment key={lang}><Outlet /></Fragment>
    </LangContext.Provider>
  );
}
